module.exports = __webpack_public_path__ + "fonts/97a61ae0291b6936137d65adc71f16a8.svg";